<template>
    <div class="col col-md-6">
        <form @submit.prevent="send">
            <input type="text" id="orderByEmail" class="form-control" v-model="email">

            <div class="my-2 text-bold" :class="{'text-success': !error, 'text-danger': error}">{{message}}</div>

            <button class="btn btn-primary" :disabled="loading">
                <icon-base :view-box-height="50"
                           :view-box-width="50"
                           :min-width="0"
                           :min-height="0"
                           :icon-color="'#fff'"
                           :height="30"
                           :width="30" :class="'align-bottom'"
                           v-if="loading">
                    <loading-icon/>
                </icon-base>
                <span v-else>Enviar</span>
            </button>
        </form>
    </div>
</template>

<script>
    import API from '../api/index';


    export default {
        props: {
            orderId: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                email: '',
                message: '',
                error: false,
                loading: false
            }
        },

        methods: {
            send() {
                this.message = '';

                if (!this.validateEmail(this.email)) {
                    return this.showError();
                }

                this.loading = true;

                API.order.email.post({email: this.email, orderId: this.orderId}).then(({detail}) => {
                    this.showSuccess(detail);
                });
            },

            showError() {
                this.message = 'El correo electrónico es inválido';
                this.error = true;
            },

            showSuccess(msg) {
                this.message = msg;
                this.error = false;
                this.loading = false;
            },

            validateEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/OrderByEmailButton.vue